export default class TraitPoints {
  constructor() {
    this.points = document.querySelectorAll('.data-point');
    this.mobilePoints = document.querySelectorAll('.data-point-text-mobile');
  }

  init() {
    if (this.points.length > 0) {
      this.addActiveClass();
    }
  }

  addActiveClass() {
    this.points.forEach((point) => {
      point.addEventListener('click', () => {
        const index = point.getAttribute('data-index'); // Pobieranie data-index z klikniętego punktu

        // Usuwanie klasy 'active' i resetowanie klas 'flex' oraz 'hidden' dla wszystkich punktów
        this.points.forEach((p) => p.classList.remove('active'));
        this.mobilePoints.forEach((mp) => {
          mp.classList.remove('flex');
          mp.classList.add('hidden');
        });

        // Dodawanie klasy 'active' do klikniętego punktu
        point.classList.add('active');

        // Znalezienie i aktualizacja odpowiadającego mobilnego punktu
        const matchingMobilePoint = Array.from(this.mobilePoints).find(
          (mp) => mp.getAttribute('data-index') === index
        );
        if (matchingMobilePoint) {
          matchingMobilePoint.classList.add('flex');
          matchingMobilePoint.classList.remove('hidden');
        }
      });
    });

    // Usuwanie klasy 'active' i resetowanie klas 'flex' oraz 'hidden' dla wszystkich punktów po kliknięciu poza punktami
    document.addEventListener('click', (e) => {
      // Sprawdzanie szerokości ekranu przed ukryciem mobilnych punktów
      if (window.innerWidth < 992) {
        // Jeśli szerokość ekranu jest mniejsza niż 992px, nie wykonuj dalszych działań
        return;
      }

      if (!e.target.closest('.data-point')) {
        this.points.forEach((point) => {
          point.classList.remove('active');
        });
        this.mobilePoints.forEach((mp) => {
          mp.classList.remove('flex');
          mp.classList.add('hidden');
        });
      }
    });
  }
}
